module.exports = __webpack_public_path__ + "static/develop-quickly-f06e6cef8a7eab9af50e5deca4d2d0a2.svg";